import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { motion } from 'framer-motion';
export function MoreTestimonials() {
  const testimonials = [{
    name: 'Carolina R.',
    location: 'Mendoza',
    pack: 'Miga Master Pro + Catering Elite',
    text: 'Antes hacía 3 docenas por semana. Ahora tengo contrato mensual con una empresa que me pide 20 docenas cada viernes. El Tomo II me cambió la vida.'
  }, {
    name: 'Florencia M.',
    location: 'Buenos Aires',
    pack: 'Miga Master Pro',
    text: 'La calculadora Miga-Math fue lo que más me sorprendió. Descubrí que estaba cobrando un 30% menos de lo que debía. Lo corregí la misma semana.'
  }, {
    name: 'Soledad P.',
    location: 'La Plata',
    pack: 'Miga Master Pro',
    text: 'Los guiones de WhatsApp me dieron una seguridad que no tenía. Antes me bloqueaba cuando me pedían precio. Ahora cierro 8 de cada 10 consultas.'
  }, {
    name: 'Valeria N.',
    location: 'Rosario',
    pack: 'Miga Master Pro + Catering Elite',
    text: 'Hice mi primer evento de 200 personas siguiendo el Planificador de Eventos. Todo salió perfecto y cobré el doble de lo que cobraba antes.'
  }];
  return <section className="py-14 bg-white" data-id="element-218">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-219">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-brand-dark mb-8" data-id="element-220">
          ❤️ MÁS EMPRENDEDORAS QUE YA LO TIENEN
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-221">
          {testimonials.map((t, idx) => <motion.div key={idx} className="bg-brand-cream p-6 rounded-2xl shadow-sm border border-brand-lightGray flex flex-col" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} data-id="element-222">
              <div className="flex text-brand-gold mb-3" data-id="element-223">
                {[...Array(5)].map((_, i) => <StarIcon key={i} fontSize="small" data-id="element-224" />)}
              </div>
              <p className="text-brand-dark text-lg font-medium mb-4 flex-grow italic" data-id="element-225">
                "{t.text}"
              </p>
              <div className="border-t border-gray-200 pt-3" data-id="element-226">
                <p className="font-bold text-brand-dark text-lg" data-id="element-227">{t.name}</p>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mt-1 text-sm text-brand-gray" data-id="element-228">
                  <span className="flex items-center gap-1" data-id="element-229">
                    <LocationOnIcon fontSize="small" className="text-brand-gold" data-id="element-230" />
                    {t.location}
                  </span>
                  <span className="hidden sm:inline text-gray-300" data-id="element-231">|</span>
                  <span className="font-medium text-brand-gold" data-id="element-232">{t.pack}</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}